import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import * as Template from "../../templates";
import * as actions from "../../actions";
import EditorField from "../../templates/modules/forms/Editor";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = `shippings`;

  const params = useParams()
  
  const navigate = useNavigate()

  const [id, setId] = useState();
  
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [name, setName] = useState(``);
  const [price, setPrice] = useState(``);
  const [min, setMin] = useState(``);
  const [submitted, setSubmitted] = useState(false);
  const [description, setDescription] = useState(``);

  const handleAboutChange = (value) => setDescription(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.shippings_store != undefined && appReducer.shippings_store.error == false) ||
        (appReducer.shippings_update != undefined && appReducer.shippings_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.shippings_store,
    appReducer.shippings_update
  ])


  useEffect(() => {
    if (appReducer.shippings_edit != undefined && id != undefined) {
      let row = appReducer.shippings_edit.data;
      setName(row.name);
      setDescription(row.description)
      setPrice(row.price);
      if (row.min != 10000000000000) {
        setMin(row.min)
      }
    }
  }, [appReducer.shippings_edit]);

  useEffect(() => {
    dispatch(actions.list(`provinces/option`));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <Template.Form>
    <Template.Input
      required
      value={name}
      label="نام"
      name="name"
      type="text"
    />
    <Template.Input
      required
      value={price}
      label="قیمت"
      name="price"
      type="text"
    />
    <Template.Input
      required
      value={min}
      label="مبلغ پایه فاکتور"
      name="min"
      type="text"
    />
    <div className={`form-group mb-3`}>
      <EditorField
      label="توضیحات"
        onEditorChange={handleAboutChange}
        value={description}
      />
      <input name="description" type="hidden" defaultValue={description} />
    </div>
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};